import { z } from "@/zod";

export const phoneNumber = z.string();
